export interface StatusFilterType {
  selectedStatuses: server.dto.StatusSmall[]
  initialStatuses: server.dto.StatusSmall[]
  filterType: server.dto.WhereInOrNotIn
}

export const getSortedStatuses = (filter: StatusFilterType) => {
  return [...filter.selectedStatuses].sort((a, b) => {
    const indexA = filter.initialStatuses.findIndex(value => value === a);
    const indexB = filter.initialStatuses.findIndex(value => value === b);
    return indexA - indexB;
  });
};

export const initialStatusFilter: StatusFilterType = {
  selectedStatuses: [],
  initialStatuses: [],
  filterType: "in"
};